export default "__VITE_ASSET___s02hZ4n__"